module.exports = __webpack_public_path__ + "static/media/speaker.77d44bd8.svg";